import {EEventType, IEventData} from 'coreClasses/events/IEvents';
import {isServer} from 'coreUtils/utils';
import AnalyticsProvidersFactory from './AnalyticsProvidersFactory';
import {IAnalyticsConfiguration} from './IAnalytics';
import AbstractAnalyticProvider from './providers/AbstractAnalyticProvider';
import Manager from 'coreClasses/Manager';

/**
 * Represents AnalyticsMgr
 */
class AnalyticsMgr extends Manager {
	/**
	 * Initialize Analytics Manager
	 */
	initialize() {
		const analyticsConfiguration: IAnalyticsConfiguration = this.managerRepository
			.getConfigurationsMgr()
			.get('analytics');
		const analyticsFactory: AnalyticsProvidersFactory = new AnalyticsProvidersFactory(this.managerRepository);

		if (analyticsConfiguration?.providers) {
			Object.keys(analyticsConfiguration.providers).forEach((key) => {
				const analyticProvider: AbstractAnalyticProvider =
					analyticsFactory.create(key, analyticsConfiguration.providers[key]);

				if (analyticProvider) {
					this.subscribe(analyticProvider);
				}
			});
		}
	}

	/**
	 * Tracks analytics event
	 * @param {EEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 */
	track(eventType: EEventType, eventData: IEventData): void {
		if (!isServer) {
			this.notify(eventType, eventData);
		}
	}

	/**
	 * Tracks analytics event
	 * @param {EEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 */
	update(eventType: EEventType, eventData: IEventData): void {
		this.track(eventType, eventData);
	}
}

export default AnalyticsMgr;
